/**
 * Keep aligned with king-monorepo `vnem-allocation.constants.ts` and devData `ALLOCATION_SUM_EPSILON` (WEB-7250).
 * @see vnemAllocationMath.test.ts
 */
export const ALLOCATION_SUM_EPSILON = 0.01

export const VNEM_FUTURE_END_DATE_ONLY = '2030-12-31'

const toDateOnly = (value: string | Date | null | undefined): string | null => {
  if (value == null || value === '') return null
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date.toISOString().slice(0, 10)
}

const allocationEndDateOnly = (endDate: string | Date | null | undefined): string => {
  return toDateOnly(endDate) ?? VNEM_FUTURE_END_DATE_ONLY
}

/** UTC calendar day `asOf` in [start, end) — matches backend `allocationInEffectOnDay`. */
export const allocationInEffectOnDateOnly = (
  startDate: string | Date | null | undefined,
  endDate: string | Date | null | undefined,
  asOf: string
): boolean => {
  const start = toDateOnly(startDate)
  if (start == null) return false
  const end = allocationEndDateOnly(endDate)
  return start <= asOf && asOf < end
}

export const sumInEffectOverlayPercentages = (
  allocations: Array<{ meterCuid: string; percentage: number; startDate: Date | null; endDate: Date | null }>,
  asOf: string,
  overrides: Map<string, number>
): number => {
  const inEffect = allocations.filter((row) => allocationInEffectOnDateOnly(row.startDate, row.endDate, asOf))
  const proposed = new Map<string, number>(inEffect.map((row) => [row.meterCuid, Number(row.percentage)]))
  for (const [meterCuid, percentage] of overrides.entries()) {
    if (!proposed.has(meterCuid)) {
      continue
    }
    proposed.set(meterCuid, percentage)
  }
  return [...proposed.values()].reduce((sum, value) => sum + value, 0)
}
